<span class="label">{{label}}</span>
<mat-slide-toggle class="switch"
                  [attr.disabled]="formControl?.disabled"
                  [formControl]="formControl"
                  (change)="onSwitchChange($event)">
</mat-slide-toggle>
